module["exports"] = [
  "#{city_root}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/address/city.js
// module id = 1688
// module chunks = 0